import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router, NavigationEnd } from '@angular/router';
import { NavItem } from 'src/app/shared/model/common/nav-item';
import { NavService } from 'src/app/shared/service/nav.service';
import { AuthenticationService } from 'src/app/shared/service/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
    ])
  ]
})
export class MenuListComponent implements OnInit {

  expanded: boolean = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem;
  @Input() depth: number = 0; // Set default value

  constructor(public navService: NavService, public authService: AuthenticationService, public router: Router) {}

  ngOnInit(): void {
    // Expand the menu if it's currently active
    this.expanded = this.isRouteActive(this.item);

    // Listen to route changes to update active state dynamically
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.expanded = this.isRouteActive(this.item);
    });
  }

  isRouteActive(item: NavItem): boolean {
    if (item.route && this.router.isActive(item.route, false)) {
      return true;
    }
    return item.children ? item.children.some(child => this.isRouteActive(child)) : false;
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }
}
